import { useAuth0 } from '@auth0/auth0-react';
import { useCallback } from 'react';

import { LoginExperience } from '../../../auth/types';

export function useClientLogin(): {
  handleLogin: () => void;
  isAuthenticated: boolean;
} {
  const { loginWithRedirect, isAuthenticated } = useAuth0();
  const handleLogin = useCallback(() => {
    loginWithRedirect({
      authorizationParams: {
        target_login_experience: LoginExperience.CLIENT,
      },
      appState: { returnTo: location.pathname },
    });
  }, [loginWithRedirect]);

  return { handleLogin, isAuthenticated };
}
